export const purposeItems = [
  {
    value: '업무공유',
    value_en: 'Work Sharing',
    value_ja: '業務共有',
    key: 'work_sharing',
    id: 1,
    active: true,
  },
  // {
  //   value: '업무보고',
  //   value_en: 'Reporting work',
  //   value_ja: '業務報告',
  //   key: 'work_reporting',
  //   id: 2,
  // },
  // {
  //   value: '업무지시',
  //   value_en: 'Giving work instructions',
  //   value_ja: '業務指示',
  //   key: 'work_orders',
  //   id: 3,
  // },
  {
    value: '협업요청',
    value_en: 'Requesting collaboration',
    value_ja: '協力依頼',
    key: 'collaboration_requests',
    active: true,
    id: 4,
  },
  // {
  //   value: '발표',
  //   value_en: 'Presentation',
  //   value_ja: '発表',
  //   key: 'announcements',
  //   id: 5,
  // },
  // {
  //   value: '조언하기',
  //   value_en: 'Giving advice',
  //   value_ja: '助言する',
  //   key: 'give_advice',
  //   id: 6,
  // },
  {
    value: '조언받기',
    value_en: 'Receiving advice',
    value_ja: '助言を受ける',
    key: 'get_advice',
    active: true,
    id: 7,
  },
  {
    value: '잡담',
    value_en: 'Chatting',
    value_ja: '雑談',
    key: 'chat',
    active: true,
    id: 8,
  },
]

export const customPurpose = {
  value: '직접입력',
  value_en: 'Custom input',
  value_ja: '直接入力',
  id: 9,
}
